import React from "react";

export const EntityPopupContext = React.createContext();
